
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGenerator as ObiGeneratorElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-generator.js';
 
 
 

 
 export const ObiGenerator = createComponent({
   react: React,
   tagName: 'obi-generator',
   elementClass: ObiGeneratorElement,
   events: {
     
   }
  });
 
 